import { createSlice } from "@reduxjs/toolkit";

export const paymentReportSlice=createSlice({
    name:'paymentReportSlice',
    initialState:{
        value:undefined
    },
    reducers:{
        get_payment_report:(state,action)=>{
            state.value=action.payload.paymentReportData
        }
    }
})
export const {get_payment_report} = paymentReportSlice.actions;
export default paymentReportSlice.reducer